import React from "react";
import "./FirstStepSection.css";
import { useAppData } from "../contexts/AppDataContext";

const BASE = process.env.PUBLIC_URL || "landing-page";

export default function FirstStepSection() {
  const { appData, loading } = useAppData();

  const handleDownloadClick = (url, platform) => {
    if (url) {
      window.open(url, "_blank", "noopener,noreferrer");
    } else {
      console.log(`${platform} link not available`);
    }
  };

  return (
    <section className="fss" dir="ltr">
      <div className="fss__content" dir="rtl">
        <h2>
          <span>خطوتك</span> الأولى
        </h2>
        <p className="fss__lead">الحياة ما تنتظر.. ليش أنت تنتظر؟</p>
        <p>
          حمل تحرر الآن وابدأ رحلة حقيقية نحو نفسك. <br />
          رحلة تستحقها بكل تفاصيلها.
        </p>

        <div className="fss__buttons">
          {loading ? (
            <>
              <div className="btn btn--android btn--loading">جارٍ التحميل...</div>
              <div className="btn btn--ios btn--loading">جارٍ التحميل...</div>
            </>
          ) : (
            <>
              {appData?.androidAppLink ? (
                <a
                  href={appData.androidAppLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn--android"
                >
                  تحميل Android
                </a>
              ) : (
                <div className="btn btn--android btn--disabled">
                  تحميل Android غير متوفر
                </div>
              )}

              {appData?.iosAppLink ? (
                <a
                  href={appData.iosAppLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn--ios"
                >
                  تحميل iOS
                </a>
              ) : (
                <div className="btn btn--ios btn--disabled">
                  تحميل iOS غير متوفر
                </div>
              )}
            </>
          )}
        </div>
      </div>

      <div className="fss__art" aria-hidden="true">
        <img
          src={`${BASE}/assets/fssBanner.png`}
          alt="واجهة التطبيق"
          loading="lazy"
          decoding="async"
          sizes="(max-width: 900px) 92vw, 600px"
        />
      </div>
    </section>
  );
}
